import React, { useCallback } from 'react';
import { Modal } from 'app-components';
import AlertMessage from '../../../components/individualPortal/dashboard/AlertMsgs/AlertMessage';
import { ModalContextType } from '../../../contexts/modalContext';
import { StyledModalBody } from '../ResetPasswordStyles';
import { SEND_EMAIL_ERROR_MODAL_KEY } from './modalConfig';

interface IModalProps extends ModalContextType {
    message?: string;
}

const SendEmailErrorModal = ({ closeModal, message }: IModalProps) => {
    const handleClose = useCallback(() => {
        closeModal(SEND_EMAIL_ERROR_MODAL_KEY);
    }, [closeModal]);

    return (
        <StyledModalBody>
            <Modal id={SEND_EMAIL_ERROR_MODAL_KEY} data-testid="alternateEmailModalError">
                <Modal.Header
                    id="alternateEmailModalErrorHeader"
                    titleId={'resetPassword.sendEmail.modal.error.title'}
                    onHide={handleClose}
                    data-testid="error-modal-header"
                />
                <Modal.Body data-testid="alternateEmailModalBody">
                    <AlertMessage showIcon={false} content={message} type="error" />
                </Modal.Body>
            </Modal>
        </StyledModalBody>
    );
};

export default SendEmailErrorModal;
